<template>
  <div class="box">
    <div class="el-row tip">
      <el-col class="tip-info" :span="12">
        <span class="info-label">经度:</span>
        <el-input
        style="width:calc(100% - 60px)"
          size="small"
          v-model.trim="position.lng"
          @change="changePosition"
        ></el-input>
      </el-col>
      <el-col class="tip-info" :span="12">
        <span class="info-label">纬度:</span>
        <el-input
        style="width:calc(100% - 60px)"
          size="small"
          v-model.trim="position.lat"
          @change="changePosition"
        ></el-input>
      </el-col>
    </div>
    <div class="mapbox">
      <baidu-map
        class="map"
        ref="map"
        v-if="center.lng != 0"
        :center="center"
        :zoom="15"
        :scroll-wheel-zoom="true"
        :double-click-zoom="false"
        :mapClick="false"
        @click="sel"
      >
        <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
        <bm-marker
          :position="position"
          :dragging="false"
          animation="BMAP_ANIMATION_BOUNCE"
          :icon="{
            url: require('@/assets/img/edu/marker_sprite.png'),
            size: { width: 20, height: 40 }
          }"
        >
        </bm-marker>
      </baidu-map>
    </div>
  </div>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
name: "subordMap";
export default {
  props: {
    actionDataBox: {
      type: Boolean,
      default: {
        return: false
      }
    },
    // 经纬度
    lngLat: {
      type: String,
      default: {
        return: ""
      }
    }
  },
  data() {
    return {
      // 百度地图
      center: {
        lng: 113.665412,
        lat: 34.757975
      },
      position: {},
      lngLatString: ""
    };
  },
  created() {},
  mounted() {},
  watch: {
    actionDataBox: {
      handler: function(newVal) {
        this.getPosition();
      },
      immediate: true
    }
  },
  methods: {
    getPosition() {
      // console.log(this.lngLat);
      let lngAndLat = this.lngLat;
      if (lngAndLat == "") {
        // 默认设为郑州市经纬度
        lngAndLat = "113.665412,34.757975";
      }
      this.$emit("getLngLat", lngAndLat);
      let lngLat = lngAndLat.split(",");
      this.center.lng = lngLat[0];
      this.center.lat = lngLat[1];
      // console.log(this.center);
      this.position = this.center;
    },
    sel({ type, target, point, pixel, overlay }) {
      // console.log(point)
      this.position = point;
      this.changePosition();
    },
    changePosition() {
      this.lngLatString = this.position.lng + "," + this.position.lat;
      // console.log(this.lngLatString)
      this.$emit("getLngLat", this.lngLatString);
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  .tip {
    width: 100%;
    padding: 10px;
    .tip-info {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .info-label {
      width: 50px;
    }
  }
  .mapbox {
    width: 100%;
    height: 300px;
    .map {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
